// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.priority_fees_row_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 50px;
}


.priority_fees_submit_button {
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.priority_fees_submit_button:disabled {
  background-color: #96b2fa;
  color: white;
  border-radius: 5px;
  border: solid 1px #96b2fa;
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.priority_fees_submit_box{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: -webkit-fill-available;
  margin-top: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserMarginFees/userMarginFees.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;;AAGA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB","sourcesContent":["\n.priority_fees_row_box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 50px;\n}\n\n\n.priority_fees_submit_button {\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.priority_fees_submit_button:disabled {\n  background-color: #96b2fa;\n  color: white;\n  border-radius: 5px;\n  border: solid 1px #96b2fa;\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.priority_fees_submit_box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: -webkit-fill-available;\n  margin-top: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
